module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic02.58d1a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic02.jpg
// module id = 599
// module chunks = 1